import React, { ReactNode, createContext } from "react";
import { AuthContextType } from "../types/AuthTypes";
import useLocalStorage from "../hooks/useLocalStorage";

const initialState: AuthContextType = {
  isAuthenticated: false,
  setAuthStatus: () => {},
};

type AuthProviderProps = {
  children: ReactNode;
};

const AuthContext = createContext(initialState);

function AuthProvider({ children }: AuthProviderProps) {
  const [auth, setAuth] = useLocalStorage("auth-ts", {
    isAuthenticated: initialState.isAuthenticated,
  });

  const setAuthStatus = (isAuthenticated: boolean) => {
    setAuth({
      ...auth,
      isAuthenticated,
    });
  };

  return (
    <AuthContext.Provider value={{ ...auth, setAuthStatus }}>
      {children}
    </AuthContext.Provider>
  );
}

export { AuthProvider, AuthContext };
